import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
// Lazy-load below-fold sections to reduce initial JS bundle
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const CurriculumSection = lazy(() => import('../components/CurriculumSection').then(m => ({
  default: m.CurriculumSection
})));
const ResultsSection = lazy(() => import('../components/ResultsSection').then(m => ({
  default: m.ResultsSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const BonusesSection = lazy(() => import('../components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
export function SalesPage() {
  useEffect(() => {
    // SEO: Set document title
    document.title = 'Dominá la Inteligencia Artificial — Curso Práctico de IA';
    // SEO: Inject meta description if not present
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Curso práctico para crear imágenes, videos, voces y contenido con inteligencia artificial. 13 clases en video, acceso inmediato y de por vida. Precio de lanzamiento $19.990 ARS.';
    // SEO: Inject Open Graph tags if not present
    const ogTags: Record<string, string> = {
      'og:title': 'Dominá la Inteligencia Artificial — Curso Práctico de IA',
      'og:description': 'Aprendé a usar IA para crear imágenes, videos, voces y contenido. 13 clases prácticas, 3 bonos especiales, acceso de por vida.',
      'og:type': 'website',
      'og:image': 'https://cdn.magicpatterns.com/uploads/57Y8FiC3YYebFmDiuQ2R2d/hf_20260315_012328_38fb8058-a30e-48e2-998a-84287ec8d514.jpg',
      'og:image:width': '1200',
      'og:image:height': '675'
    };
    const createdOgTags: HTMLMetaElement[] = [];
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
        createdOgTags.push(tag);
      }
      tag.content = content;
    });
    // SEO: Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = window.location.href.split('?')[0];
      document.head.appendChild(canonical);
    }
    // SEO: Add language attribute
    document.documentElement.lang = 'es';
    // Meta Pixel — Facebook/Meta
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      } as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '2043786956475160');
    (window as any).fbq('track', 'PageView');
    // Noscript fallback pixel
    let noscriptImg = document.getElementById('fb-pixel-noscript') as HTMLImageElement | null;
    if (!noscriptImg) {
      noscriptImg = document.createElement('img');
      noscriptImg.id = 'fb-pixel-noscript';
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = 'https://www.facebook.com/tr?id=2043786956475160&ev=PageView&noscript=1';
      document.body.appendChild(noscriptImg);
    }
    return () => {
      createdOgTags.forEach(tag => {
        if (tag.parentNode) tag.parentNode.removeChild(tag);
      });
    };
  }, []);
  return <main className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#a855f7] selection:text-white font-sans" data-id="element-221">
      {/* Above-fold: loaded eagerly */}
      <HeroSection data-id="element-222" />
      <ProblemSection data-id="element-223" />

      {/* Below-fold: lazy-loaded to reduce initial JS */}
      <Suspense fallback={null} data-id="element-224">
        <SolutionSection data-id="element-225" />
        <CurriculumSection data-id="element-226" />
        <ResultsSection data-id="element-227" />
        <TestimonialsSection data-id="element-228" />
        <BonusesSection data-id="element-229" />
        <PricingSection data-id="element-230" />
        <GuaranteeSection data-id="element-231" />
        <FinalCTA data-id="element-232" />
      </Suspense>

      <SocialProofPopup data-id="element-233" />
    </main>;
}